import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { PrimaryButton } from '../../../components/button';
import { DeleteWatcherButton } from '../../../watchers/components/delete-watcher-button/DeleteWatcherButton';
import { useWatcherButton } from './useWatcherButton';
import {
  WatcherSearchQueryEnum,
  WatcherQueryParamsEnum,
} from '../../../watchers/watchers.types';
import styles from './search_commentary_watcher.module.scss';
import { useRestrictedModal } from '../../../components/modal/useRestrictedModal';
import { useUser } from '../../../user/useUser';

type Props = {
  query: string;
};

export const SearchCommentaryWatcher: FC<Props> = ({ query }) => {
  const source = 'create_search_commentary_watcher';
  const [createWatcher, isWatched, deleteWatcher] = useWatcherButton({
    source,
    searchType: WatcherSearchQueryEnum.COMMENTARY,
  });
  const { openRestrictedModal } = useRestrictedModal();
  const { accessPremium } = useUser();

  const createCommentaryWatcher = () => {
    if (accessPremium) {
      createWatcher([
        {
          type: WatcherSearchQueryEnum.COMMENTARY,
          query: {
            query,
            type: WatcherQueryParamsEnum.COMMENTARY,
          },
        },
      ]);
    } else {
      openRestrictedModal({ source });
    }
  };

  return (
    <div className={styles.container}>
      {!isWatched && (
        <PrimaryButton
          onClick={createCommentaryWatcher}
          iconLeft="notifications_none"
          dataName="create-commentary-watcher"
        >
          <FormattedMessage id="search/components/search-watcher/SearchCommentaryWatcher.tsx/1" />
        </PrimaryButton>
      )}
      {isWatched && (
        <DeleteWatcherButton
          place="bottom"
          deleteWatcher={deleteWatcher}
          tooltipId="search-commentary-watcher-button"
        />
      )}
    </div>
  );
};
